<div id="pdp-homr-sliders">
	<div class="hmf-mx-s">
		<div class="description-header hmf-body-bold-l hmf-header-bold-md-s hmf-display-flex hmf-justify-content-flex-start hmf-mb-s">
			Overview
		</div>

		@if (productStatsSlider()?.title) {
			<div class="slider-title html-header-bold-m">{{ productStatsSlider()?.title }}</div>
		}

		@for (slider of productStatsSlider(); let last = $last; track trackByTitle($index, slider)) {
			<div class="slider"
				[ngClass]="{ 'hmf-mb-0': last, 'hmf-mb-m': !last }">
				<div class="slider-title hmf-header-bold-xs">{{ slider.title }}</div>
				<div class="hmf-display-flex hmf-align-items-start hmf-justify-content-between hmf-mt-s">
					@for (item of slider.productStatLine; track trackByStatLine($index, item)) {
						<div class="slider-container">
							<div class="slider-bar" [ngClass]="{'selected': item.highlight === 'true'}"></div>
							<div class="hmf-text-align-center hmf-mt-xs label-base-subtle hmf-body-xs hmf-body-lg-s">{{ item.title }}</div>
						</div>
					}
				</div>
			</div>
		}
	</div>
</div>
